import { withCompInfo } from '@wix/editor-elements-integrations'
import { AppWidgetPropsCSSVars, AppWidgetDefinition } from './AppWidget'
import { getHeightInPixels } from '@wix/editor-elements-common-utils'
import type { AppWidgetProps, ResponsiveAppWidgetProps } from './AppWidget'

export const css = withCompInfo<AppWidgetPropsCSSVars | {}, AppWidgetDefinition>()(
	['skin', 'compLayout', 'compSingleLayout', 'isOneDocMigrated'],
	({ skin, compLayout, compSingleLayout, isOneDocMigrated }) => {
		return skin === 'AppWidgetLoaderSkin'
			? { height: isOneDocMigrated ? `${getHeightInPixels(compSingleLayout)}px` : `${compLayout.height}px` }
			: {}
	}
)

export const props = withCompInfo<AppWidgetProps | ResponsiveAppWidgetProps | {}, AppWidgetDefinition>()(
	// @ts-ignore
	['uiType', 'skin', 'compMeshProps', 'responsiveContainerProps', 'containerRootClassName'],
	({
		uiType,
		skin,
		compMeshProps,
		// @ts-ignore
		responsiveContainerProps: containerProps,
		// @ts-ignore
		containerRootClassName,
	}) => {
		if (uiType === 'Responsive') {
			return {
				skin,
				containerProps,
				containerRootClassName,
			}
		} else if (uiType === 'Classic') {
			return {
				skin,
				meshProps: compMeshProps,
			}
		} else {
			return {}
		}
	}
)
